import React, { Component, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react';




class CancelPOAcceptance extends Component {

    constructor(props) {
        super(props);
        this.state={
            writeComment:"",
            fileUploadIds:[],//upload id
        }
        
        this.modal= this.modal.bind(this); 
        
    }

   
    modal() {
        this.props.toggleCancelPOAcceptanceModal(false)
        
    }  
    hChange = (e)=>{
        let writeComment = this.state.writeComment
        writeComment = e.target.value;
        //let fileUploadIds =[this.state.revisedPayload.param.uploadId]
        this.setState(
            {
                //fileUploadIds,
                writeComment});
    }
    formSaveAction = async ()=>{
        this.modal()
        swal("PO Acceptance has been Rejcted for PO No.",{button:false,icon:"error"})
    }

 render(){
    
 
 return(
     <div>
      
        <div>
        <Modal  isOpen={this.props.action} >
            <div className={"modal-bg" + (this.props.action === 'false'  ? 'open' : '')}>
                <div className={"modal-bg" + (this.state.OpenVersionModal == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >Cancel PO Acceptance</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                <ModalBody Style="modal-body modalbodyssmall">
                        
                    <div className="row ">
                        <div className="col-8"></div>
                        <div className="col-4 pb-2">
                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                        </div>
                    </div> 
                    <div className="row mt-4 ml-1">
                        Are you sure you want to reject PO Acceptance for PO No. :
                    </div>
                    <div className="row mt-4">
                        <div className="col-sm-6">
                            Comment :
                        </div>
                        <div className="col-sm-6">
                            <textarea className="form-control" onChange={(e)=>this.hChange(e)} ></textarea>
                        </div>
                    </div>
                </ModalBody>
                </div>
                <div className="">
                    <ModalFooter FooterStyle="modal-footer">
                        <div>
                            <button className="btn2 btn-sms1 mt-2 ml-2 float-right" onClick={()=>this.formSaveAction()} type="submit">Reject</button> 
                            <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={this.modal} type="submit">Close</button> 
                        </div>
                    </ModalFooter>
                </div>
            </div>
        </Modal>         
        </div>
        
    </div>
       
     
 )
 
  }
}
 

export default CancelPOAcceptance;